<script setup lang="ts">
import GenericError from '~/components/user-interface/generic-error.vue';
import GenericLoader from '~/components/user-interface/generic-loader.vue';
import { useWinnersData } from '~/composables/useStates/useWinnersData';
const { winnersLoading, currentWinners } = useWinnersData();
</script>
<template>
  <div>
    <LazyWinnersSectionHeader
      title="all-winners"
      alt="All Winners"
      icon-name="winnersIcon"
    />
    <GenericLoader v-if="winnersLoading" :standalone="true" />
    <div v-else class="w-full max-h-96 overflow-y-auto rounded-lg">
      <LazyWinnersBigWinnersTableContent v-if="currentWinners?.length > 0" />
      <GenericError v-else state="danger" class="m-10" :scroll-to-view="false">
        {{ $t('all-winners-table-empty') }}
      </GenericError>
    </div>
  </div>
</template>
